module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_8019.6d15ff39.png";